export { default as main } from '@components/main/main.reducer';
export { default as mapcontainer } from '@components/map-components/map-container/map-container.reducer';
export { default as covidpanel } from '@components/covid-panel/covid-panel.reducer';
